<template>
  <v-container fluid class="py-0">
    <v-row justify="center">
      <v-col cols="12" md="10" mx-auto>
        <v-card flat v-if="lAction === 'view'">
          <v-card-title>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                class="pa-0 mt-1"
                append-icon="mdi-account-search-outline"
                :placeholder="$vuetify.breakpoint.smAndUp?'Search user by name, desig, etc...':'Search'"
                single-line
                hide-details
                v-model="search"
                outlined
                clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-download-as
                :headers="userHeadSm"
                :items="users"
                title="User list"
                ></v-download-as>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text class="pa-1">
            <v-data-table
            :headers="userHeadSm"
            :items="users"
            hide-default-footer
            class="elevation-2"
            :search="search"
            :mobile-breakpoint="0"
            sort-by="user_name"
            >
            <template slot="item" slot-scope="props">
              <v-menu
              absolute
              offset-y
              >
              <template v-slot:activator="{ on }">
                <tr v-on="on">
                  <td><v-avatar size="36px">
                    <img v-if="props.item.avatar_url" :src="handy.loadImg(props.item.avatar_url)"/>
                    <v-icon v-else class="grey lighten-2">mdi-account</v-icon>
                  </v-avatar>
                </td>
                <td>{{ props.item.user_name }}</td>
                <td>{{ props.item.role_name }}</td>
                <td>{{ props.item.vendor_emp_id }}</td>
                <td>{{ props.item.emp_name }}</td>
                <td>{{ props.item.emp_phone }}</td>
                <td>{{ props.item.is_disabled }}</td>
              </tr>
            </template>
            <!-- menu -->
            <v-list>
              <v-list-item @click="prepareUpdate('update', props.item)">
                <v-list-item-avatar><v-icon>mdi-account-edit-outline</v-icon></v-list-item-avatar>
                <v-list-item-title>Edit details</v-list-item-title>
              </v-list-item>
              <v-list-item @click="prepareUpdate('password-reset', props.item)">
                <v-list-item-avatar><v-icon>mdi-lock-reset</v-icon></v-list-item-avatar>
                <v-list-item-title>Reset password</v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item v-if="props.item.is_disabled === 'No'" @click="prepareUpdate('disable', props.item)">
                <v-list-item-avatar><v-icon>mdi-account-off-outline</v-icon></v-list-item-avatar>
                <v-list-item-title>Disable access</v-list-item-title>
              </v-list-item>
              <v-list-item v-else @click="prepareUpdate('enable', props.item)">
                <v-list-item-avatar><v-icon>mdi-account-check-outline</v-icon></v-list-item-avatar>
                <v-list-item-title>Enable access</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
<v-container v-if="lAction === 'create' || lAction === 'update' || lAction === 'password-reset'" class="pa-0" grid-list-md fluid full-height>
  <v-form ref="lForm" id="form" @submit.prevent="saveChanges(lAction)">
    <v-card flat>
      <v-card-title class="px-0 py-2">
        {{ lAction === 'password-reset' ? ('Reset Password For ' + lUser.user_name) : (handy.startWithUpper(lAction) + ' User') }}
      </v-card-title>
      <v-card-text class="px-0 py-3">
        <v-layout row wrap>
          <v-flex xs6 v-if="lAction !== 'password-reset'">
            <v-text-field
            v-model="lUser.user_name"
            label="User Name"
            :rules="[rules.required]"
            hide-details
            maxlength="25"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 v-if="lAction !== 'password-reset'">
            <v-switch
            v-model="lUser.is_active"
            label="Active"
            hide-details
            ></v-switch>
          </v-flex>
          <v-flex xs6 v-if="lAction !== 'password-reset'">
            <v-select
            v-model="lUser.role_id"
            label="Role"
            :items="rolesList"
            item-text="role_name"
            item-value="role_id"
            :rules="[rules.required]"
            hide-details
            ></v-select>
          </v-flex>
          <v-flex xs6 v-if="lAction !== 'password-reset'">
            <v-combobox
            v-model="lUser.emp_pair"
            label="Employee"
            :items="empList"
            item-value="emp_id"
            item-text="emp_name_with_id"
            :rules="[rules.required]"
            hide-details
            @input="loadEmail()"
            ></v-combobox>
          </v-flex>
          <!-- passwords fields for create or password reset actions -->
          <v-flex xs6 v-if="lAction !== 'update'">
            <v-text-field
            v-model="lUser.user_pwd"
            label="Password"
            :rules="[rules.required]"
            hide-details
            maxlength="15"
            type="password"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 v-if="lAction !== 'update'">
            <v-text-field
            v-model="lUser.retype_pwd"
            label="Re-type Password"
            :rules="[rules.required]"
            hide-details
            maxlength="15"
            type="password"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 v-if="lAction !== 'update'" class="pt-4">
            <v-text-field
            v-model="lUser.emp_email"
            :label="'Notify ' + (lAction === 'create' ? 'Username & ' : '') + 'Password Via E-Mail'"
            maxlength="50"
            outlined
            hint="Leave it empty if user no need to be notified"
            persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex xs12 v-if="lAction === 'update'">
            <v-switch
            v-model="lUser.is_all_proj_access"
            label="All Project Access"
            hide-details
            ></v-switch>
          </v-flex>
          <v-flex xs6 v-if="lAction === 'update'">
            <v-card>
              <v-card-title class="pa-2 primary--text grey lighten-4">
                Project Access ({{lUser.is_all_proj_access ? 'All' : lUser.proj_list.length}})
                <v-spacer></v-spacer>
                <v-btn small :disabled="lUser.is_all_proj_access === 1" @click="prepareAddProj()">Add</v-btn>
              </v-card-title>
              <v-card-text class="pa-0">
                <v-data-table
                :headers="projHd"
                :items="lUser.is_all_proj_access ? [] : lUser.proj_list"
                hide-default-footer
                disable-pagination
                :search="search"
                sort-by="proj_name"
                :no-data-text="lUser.is_all_proj_access ? 'All projects' : 'No projects'"
                :mobile-breakpoint="0">
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs6 v-if="lAction === 'update'">
          <v-card>
            <v-card-title class="pa-2 primary--text grey lighten-4">
              Point Of Contact ({{lUser.proj_poc_list && lUser.proj_poc_list.length}})
            </v-card-title>
            <v-card-text class="pa-0">
              <v-data-table
              :headers="projHd"
              :items="lUser.proj_poc_list"
              hide-default-footer
              disable-pagination
              :search="search"
              sort-by="proj_name"
              no-data-text="Not a POC for any projects"
              :mobile-breakpoint="0">
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-card-text>
  <v-card-actions>
    <v-btn v-if="lAction === 'update'" @click="deleteUser()">delete</v-btn>
    <v-spacer></v-spacer>
    <v-btn @click.stop="lAction = 'view'">Close</v-btn>
    <v-btn type="submit" color="accent" :disabled="beingSaved">save</v-btn>
  </v-card-actions>
</v-card>
</v-form>
</v-container>

<!-- add project access -->
<v-dialog v-model="showProj" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12>
      <v-form ref="pForm" @submit.prevent="addRemProjPOC(pAction)">
        <v-card>
          <v-card-title class="title grey lighten-4">
            Add Project Access
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-combobox
                v-model="curProject"
                label="Project"
                :items="projectList"
                item-text="proj_name"
                item-value="proj_id"
                :rules="[rules.required]"
                ></v-combobox>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn text @click.stop="showProj = false">Cancel</v-btn>
            <v-btn text type="submit" color="accent" :disabled="beingSaved">Add</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<v-btn
:style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:20px; right:15px;':'bottom:15px; right:15px;')"
dark fab fixed color="accent" v-if="lAction === 'view'"
@click.native="prepareCreate">
<v-icon>mdi-plus</v-icon>
</v-btn>
</v-col>
</v-row>
<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-container>
</template>

<script>
import VDownloadAs from '@/components/VDownloadAs.vue'
import handy from '@/utils/handy'
import config from '@/config/app-cfg'


export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      config: config,
      handy: handy,
      rules: handy.rules,
      search: '',
      beingSaved: false,
      lAction: 'view',
      users: [],
      lUser: {},
      rolesList: [],
      empList: [],
      userHeadSm: [
        { text: 'Avatar', value: 'avatar_url', sortable: false },
        { text: 'Username', value: 'user_name' },
        { text: 'Role', value: 'role_name' },
        { text: 'Emp. Id', value: 'vendor_emp_id' },
        { text: 'Emp. Name', value: 'emp_name' },
        { text: 'Phone', value: 'emp_phone' },
        { text: 'Disabled?', value: 'is_disabled' }
      ],
      projHd: [
        { text: 'Project Name', value: 'proj_name'}
      ],
      showMenu: false,
      projectList: [],
      showProj: false,
      curProject: '',
      pAction : ''
    }
  },
  created () {
    this.loadUsers()
  },
  mounted () {

  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    getEmptyUser () {
      return {
        vendor_id: config.VENDOR_ID,
        user_name: '',
        role_id: '',
        emp_pair: '',
        user_pwd: '',
        retype_pwd: '',
        is_active: true,
        proj_poc_list: []
      }
    },
    prepareCreate () {
      this.lUser = this.getEmptyUser()
      this.loadUserRoles()
      this.loadEmployee()
      this.lAction = 'create'
    },
    prepareUpdate (action, curUser) {
      this.lUser = Object.assign({}, curUser) // keep the original object safely before changes
      if (action === 'update') {
        // prepare update
        this.loadUserRoles()
        this.loadEmployee()
        this.loadProjPOC() // list of projects & that this user is poc
        this.lUser.emp_pair = {emp_id: this.lUser.emp_id, emp_name_with_id: (this.lUser.emp_name + ' (' + this.lUser.vendor_emp_id + ')')}
        this.lAction = 'update'
      } else if (action === 'password-reset') {
        this.lAction = 'password-reset'
      } else if (action === 'enable' || action === 'disable') {
        if (!confirm('Sure, you want to ' + action + ' the access for user "' + curUser.user_name + '"?')) {
          return
        }
        this.lUser.is_active = action === 'enable'
        this.saveChanges(action)
      }
    },
    deleteUser () {
      this.saveChanges('delete')
    },
    saveChanges (action) {
      if (action === 'delete') {
        if (!confirm('Sure, you want to delete user "' + this.lUser.user_name + '"?')) {
          return
        }
      } else if (action === 'create' || action === 'update' || action === 'password-reset') {
        if (!this.$refs.lForm.validate()) {
          return
        } else if ((action === 'create' || action === 'update') && !this.lUser.emp_pair.emp_id) {
          this.msg('Please chose a valid employee')
          return
        } else if ((action === 'create' || action === 'password-reset') && this.lUser.user_pwd !== this.lUser.retype_pwd) {
          this.msg('Re-typed password does not match with password')
          return
        } else if (action === 'create' || action === 'update') {
          this.lUser.emp_id = this.lUser.emp_pair.emp_id
          this.lUser.role_name = this.rolesList.find(rec => rec.role_id === this.lUser.role_id).role_name // for notification
        }
      }
      // proceed with changes
      this.beingSaved = true
      this.axios.post(config.API_URL + '/user/' + action, this.lUser)
      .then(response => {
        // update the object in front end
        this.loadUsers()
        this.lAction = 'view'
        this.beingSaved = false
        if (action !== 'delete') {
          this.msg('Saved successfully' + (this.lUser.emp_email && (action === 'create' || action === 'password-reset') ? ' and notification was sent' : ''), 1)
        } else {
          this.msg('Deleted successfully', 1)
        }
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    cancelChanges () {
      this.lAction = 'view'
    },
    prepareAddProj () {
      this.pAction = 'add-proj'
      this.loadMaintenanceProject()
      this.showProj = true
    },
    addRemProjPOC (curAct, curProjId = '', curProjNm = '') {
      if (curAct === 'add-proj' || curAct === 'add-proj-poc') {
        if(!this.$refs.pForm.validate()) {
          return
        }
        curProjId = this.curProject.proj_id
        curProjNm = this.curProject.proj_name
      } else {
        if (!confirm('Sure, you want to remove the project "' + curProjNm + '"?')) {
          return
        }
      }
      // add/remove project access or poc to/from user
      if (curAct === 'add-proj') {
        this.lUser.proj_list.push({proj_id: curProjId, proj_name: curProjNm})
      } else {
        this.lUser.proj_poc_list.push({proj_id: curProjId, proj_name: curProjNm})
      }
      this.showProj = false
    },
    loadUsers () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUsersByVendor/', qry)
      .then(response => {
        this.users = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
        this.users = []
      })
    },
    loadUserRoles () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUserRolesByVendor/', qry)
      .then(response => {
        this.rolesList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
        this.rolesList = []
      })
    },
    loadEmployee () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getEmployeeByVendorId/', qry)
      .then(response => {
        this.empList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
        this.empList = []
      })
    },
    loadEmail () {
      let chosenEmp = this.lUser.emp_pair && this.lUser.emp_pair.emp_id ? this.empList.find(rec => rec.emp_id === this.lUser.emp_pair.emp_id) : ''
      this.lUser.emp_email = chosenEmp && chosenEmp.emp_email || ''
      this.lUser.gender = chosenEmp && chosenEmp.gender.toLowerCase() || ''
    },
    loadProjPOC () {
      var qry = {
        params: {
          user_id: this.lUser.user_id
        }
      }
      // list of projects that this user can access
      this.axios.get(config.API_URL + '/getProjectAccByUserId/', qry)
      .then(response => {
        this.lUser.proj_list = response.data
        // list of projects that this user is a POC
        this.axios.get(config.API_URL + '/getProjectPOCByUserId/', qry)
        .then(response => {
          this.lUser.proj_poc_list = response.data
        })
      })
      .catch(err => {
        this.msg(err.response.data)
        this.lUser.proj_poc_list = []
      })
    },
    loadMaintenanceProject () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getMaintProjByVendorId/', qry)
      .then(response => {
        this.projectList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    }
  }
}
</script>
